import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { URLS } from "globalConstants";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const ENV_URL = process.env.REACT_APP_ENV_URL;

const useInitializeEmailChangeMutation = ({
	onSuccess,
	onError,
}: {
	onSuccess: Function;
	onError: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ email }: { email: string }) => {
			return usersService.initializeEmailChange({
				email,
				confirmation_url: `${ENV_URL}${URLS.confirmEmailChange}`,
				cancellation_url: `${ENV_URL}${URLS.cancelEmailChange}`,
			});
		},
		{
			onSuccess: () => {
				onSuccess?.();
				dispatch(
					uiActions.showSuccessNotification({
						title: "Success! Check your inbox to confirm email change.",
					}),
				);
			},
			onError(error: ErrorResponse) {
				onError?.(error);
			},
		},
	);
};

export default useInitializeEmailChangeMutation;
